import type Result from 'true-myth/result';

import type { ValidatingHttpFetcherWithBaseUrl } from '~/shared/validating-http-fetcher';

import type { CvUploadResponse } from './company-profile';
import { cvUploadResponseSchema } from './company-profile';

export type UploadCV = (file: FormData) => Promise<Result<CvUploadResponse, unknown>>;

export const createUploadCV = (dependencies: {
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
}): UploadCV => {
    const { validatingCobrainerApiFetcher } = dependencies;

    return (formData: FormData) => {
        return validatingCobrainerApiFetcher.post(cvUploadResponseSchema, {
            pathname: '/cv-analysis',
            requestOptions: {
                body: formData,
            },
        });
    };
};
